<template>
  <Layout>
    <Title :height="28" imgUrl="url('@/assets/img/bg-serv-white-title.svg')">
      <img
        src="https://advservice-images.s3.amazonaws.com/solutions/Logo%2B1.png"
        class="h-24 w-auto lg:h-44"
        alt="Trabalhista Service logo"
      />
    </Title>
    <About
      title="O maior aliado de advogados trabalhistas de sucesso."
      text="Gaste menos tempo com tarefas repetitivas e atividades pequenas, e tenha disponibilidade para atender e conquistar mais clientes."
      service="trabalhista"
      video-url="https://advservice-images.s3.amazonaws.com/videos/trabalhista+service+final+.mp4"
      thumbnail-url="https://advservice-images.s3.amazonaws.com/solutions/Trabalhista%20Service.png"
    />
    <Benefits :solutionId="1" />
    <PlansComparison :solution-id="1" />
    <Solutions title="Mais soluções" />
    <Depoimentos title="Depoimentos" />
    <Faq title="Perguntas Frequentes" :questions="faqStore.questions" />
  </Layout>
</template>

<script lang="ts" setup>
import Layout from '@/components/BaseLayout/Layout.vue';
import Title from '@/components/Title/Title.vue';
import About from '@/components/About/About.vue';
import Benefits from '@/components/Benefits/Benefits.vue';
import PlansComparison from '@/components/Plans/PlansComparison.vue';
import Solutions from '@/components/Solutions/Solutions.vue';
import Depoimentos from '@/components/Depoimentos/Depoimentos.vue';
import Faq from '@/components/Faq/Faq.vue';
import { useFaqStore } from '@/store/faqStore';

const faqStore = useFaqStore();
</script>
